import { Alerts as ReuseAlerts } from '@verndale/front-end-components';

const _helpers = require("@verndale/front-end-components/lib/helpers/");

class Alerts extends ReuseAlerts {
  setupDefaults() {
    this.dom = {
      el: this.el,
      content: this.el.querySelector('.alert__content'),
      toggle: this.el.querySelector('.alert__toggle'),
      hide: this.el.querySelector('.alert__hide'),
      show: this.el.querySelector('.alert__show'),
      close: this.el.querySelector('.alert__close'),
      heading: this.el.querySelector('.alert__heading'),
    };

    this.id = this.el.dataset.id;
    this.canDismiss = this.el.dataset.canDismiss;
    this.expanded = this.el.dataset.expanded;
    this.shouldDisplayAlert();
    this.offsetCenteredTextForButtons();
  }

  addListeners() {
    if (this.dom.content && this.dom.toggle) {
      this.dom.toggle.addEventListener('click', this.handleToggle.bind(this));
    }

    if (this.dom.close) {
      this.dom.close.addEventListener('click', this.handleClose.bind(this));
    }

    this.dom.el.addEventListener('click', this.handleClick.bind(this));
  }

  offsetCenteredTextForButtons() {
    // check if the heading element has the class alert__heading-center
    if (!this.dom.heading.classList.contains('alert__heading-center')) {
      return; // exit if alert__heading-center class not present
    }

    let isToggleVisible = false;
    if (this.dom.toggle) {
      const toggleStyle = window.getComputedStyle(this.dom.toggle);
      isToggleVisible = toggleStyle.display !== 'none' && toggleStyle.visibility !== 'hidden';
    }

    let isCloseVisible = false;
    if (this.dom.close) {
      const closeStyle = window.getComputedStyle(this.dom.close);
      isCloseVisible = closeStyle.display !== 'none' && closeStyle.visibility !== 'hidden';
    }

    // remove existing classes
    this.dom.heading.classList.remove('alert__heading-has-toggle-or-close', 'alert__heading-has-toggle-and-close');

    // either toggle or close is visible
    if (isToggleVisible || isCloseVisible) {
      this.dom.heading.classList.add('alert__heading-has-toggle-or-close');
    }

    // both toggle and close are visible
    if (isToggleVisible && isCloseVisible) {
      this.dom.heading.classList.add('alert__heading-has-toggle-and-close');
    }
  }

  shouldDisplayAlert() {
    if (localStorage.getItem(this.id)) {
      return this.el.remove();
    }

    (0, _helpers.open)({
      element: this.el,
      // eslint-disable-next-line no-return-assign
      onComplete: () => {
        this.el.style.height = 'auto';
        this.el.style.display = 'block';
      }
    });
  }

  setDismissibleButton() {
    if (this.canDismiss !== 'true') {
      this.dom.close.style.display = 'none';
      return;
    }

    this.dom.close.style.display = 'block';
  }

  setExpandedAlert() {
    if (this.expanded === 'true') {
      this.handleToggle();

      const onComplete = () => {
        this.dom.content.style.display = 'block';
      };

      (0, _helpers.open)({
        element: this.el,
        onComplete
      });

      return;
    }

    this.dom.toggle.setAttribute('aria-expanded', false);
    this.collapseAlert();
  }

  expandAlert() {
    this.dom.content.style.display = 'block';
    (0, _helpers.open)({
      element: this.dom.content,
      onComplete: () => {
        this.dom.content.focus();
        this.dom.content.style.height = 'auto';
      }
    });
  }

  collapseAlert() {
    (0, _helpers.close)({
      element: this.dom.content,
      onComplete: () => {
        this.dom.content.style.display = 'none';
      }
    });
  }

  handleToggle() {
    this.disableToggle();
    if (this.dom.toggle.getAttribute('aria-expanded') === 'true') {
      this.dom.toggle.setAttribute('aria-expanded', false);
      this.collapseAlert();
    } else {
      this.dom.toggle.setAttribute('aria-expanded', true);
      this.expandAlert();
    }
    setTimeout(() => this.enableToggle(), 1000);
  }

  disableToggle() {
    this.dom.toggle.disabled = true;
  }

  enableToggle() {
    this.dom.toggle.disabled = false;
  }

  handleClose() {
    (0, _helpers.close)({
      element: this.el,
      onComplete: () => {
        localStorage.setItem(this.id, true);
        this.el.remove();
      }
    });
  }

  handleClick(e) {
    if (e.target.classList.contains('alert__toggle')
      || e.target.parentElement.classList.contains('alert__toggle')
      || e.target.classList.contains('alert__close')
      || e.target.parentElement.classList.contains('alert__close')) {
      /* empty */
    } else if (!this.dom.toggle.disabled) {
      this.handleToggle();
    }
  }
}

export default Alerts;
